// ============================================================
// DepotsEnCours — la file de dépôt, un fichier par ligne.
// ------------------------------------------------------------
// Chaque fichier a sa barre et son état : en attente, en cours, déposé,
// déjà présent ou refusé — et un refus dit POURQUOI, à côté du fichier
// concerné. Une liste de 34 noms sans état ne dirait pas lequel a échoué.
// ============================================================

import Badge from '../../ui/Badge.jsx';

const LIBELLES = {
  attente: { tone: 'neutral', label: 'En attente' },
  envoi: { tone: 'neutral', label: 'Envoi…' },
  depose: { tone: 'ok', label: 'Déposé' },
  deja: { tone: 'neutral', label: 'Déjà présent' },
  refuse: { tone: 'danger', label: 'Refusé' },
};

export default function DepotsEnCours({ file }) {
  if (!file?.length) return null;
  const finis = file.filter((e) => !['attente', 'envoi'].includes(e.etat)).length;
  return (
    <div className="depots">
      <p className="caps">{`Dépôt — ${finis} fichier(s) sur ${file.length}`}</p>
      <ul className="depots__liste">
        {file.map((e) => {
          const l = LIBELLES[e.etat] ?? LIBELLES.attente;
          return (
            <li key={e.cle} className="depots__item">
              <span className="depots__nom">{e.nom}</span>
              {/* Pas de valeur pendant l'envoi : une barre indéterminée dit
                  « ça travaille » sans inventer un pourcentage que fetch ne
                  donne pas. */}
              <progress className="depots__barre" aria-label={`Dépôt de ${e.nom}`}
                max={1} value={e.etat === 'envoi' ? undefined : e.etat === 'attente' ? 0 : 1} />
              <Badge tone={l.tone}>{l.label}</Badge>
              {e.detail ? <span className="field__hint">{e.detail}</span> : null}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
